/**
 * 记账机构管理设置查询参数数据
 */
export class BookKeepingSearchParam {
  /** 机构名称 */
  name?: string;
  /** 机构管理员名称 */
  admin_name?: string;
  /** 机构管理员电话 */
  admin_mobile?: string;
  offset: number;
  limit: number;
  constructor() {
    this.offset = 0;
    this.limit = 20;
  }
}

/**
 * 记账机构管理列表项
 */
export interface BookKeepingListItem {
  /** 主键uuid */
  uuid: string;
  /** 创建时间 */
  created_time: string;
  /** 记账机构名称 */
  name: string;
  /** 管理员名称 */
  admin_name: string;
  /** 管理员手机号 */
  admin_mobile: string;
  /** 机构地址 */
  address: string;
  /** 机构uuid */
  institution_uuid: string;
}

/**
 * 配药中心关联机构查询参数数据
 */
export interface InstitutionSearchParam {
  /** 机构管理员电话 */
  mobile?: string;
}

 /**
  * 配药中心关联机构列表项
  */
 export interface InstitutionListItem {
  /** 主键uuid */
  uuid: string;
  /** 机构名称 */
  name: string;
  /** 是否虚拟机构 */
  is_virtual: string;
  /** 管理员名称 */
  admin_name: string;
  /** 管理员手机号 */
  admin_mobile: string;
  /** 机构地址 */
  address: string;
  /** ??? */
  search_display: string;
}




// WEBPACK FOOTER //
// ./src/entity/BookKeepingEntity.ts